import { connect } from 'react-redux'
import ClientsView from '../components/ClientsView'
import { getClients, createClient, setClientVersion } from '../../../store/clients'

const mapDispatchToProps = {
  getClients,
  createClient,
  setClientVersion,
}

const mapStateToProps = (state) => {
  return {
    clients: state.clients.clients,
    createdClient: state.clients.createdClient,
    updatedClient: state.clients.updatedClient,
    ui: state.ui,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientsView)



// WEBPACK FOOTER //
// ./src/routes/Clients/containers/ClientsContainer.jsx